var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "top-menu nav justify-content-center" }, [
    _c("li", { staticClass: "nav-item" }, [
      _c(
        "a",
        {
          staticClass: "nav-link",
          attrs: { id: "cosaFare", href: "javascript:void(0)" },
          on: {
            click: function($event) {
              return _vm.cosaFareNY()
            }
          }
        },
        [_vm._v(_vm._s(_vm.TOP_LINK_COSA_FARE))]
      )
    ]),
    _vm._v(" "),
    _vm.TOP_LINK_CAMBIA_ISOLA !== undefined
      ? _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              staticClass: "nav-link",
              attrs: { id: "cambiaIsola", href: "javascript:void(0)" },
              on: {
                click: function($event) {
                  return _vm.cambiaIsola()
                }
              }
            },
            [_vm._v(_vm._s(_vm.TOP_LINK_CAMBIA_ISOLA))]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("li", { staticClass: "nav-item" }, [
      _c(
        "a",
        {
          staticClass: "nav-link",
          attrs: {
            id: "chiSiamo",
            href: _vm.TOP_LINK_CHI_SIAMO_URL,
            target: "_blank"
          },
          on: { click: _vm.trackHomeChiSiamo }
        },
        [_vm._v(_vm._s(_vm.TOP_LINK_CHI_SIAMO))]
      )
    ]),
    _vm._v(" "),
    !_vm.isAuthenticated()
      ? _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              staticClass: "btn",
              attrs: { href: "javascript:void(0)" },
              on: { click: _vm.loginAgenzia }
            },
            [_vm._v(_vm._s(_vm.TOP_LINK_AGENZIA))]
          )
        ])
      : _c("li", { staticClass: "nav-item" }, [
          _c(
            "a",
            {
              staticClass: "btn",
              attrs: { href: "javascript:void(0)" },
              on: { click: _vm.logoutAgenzia }
            },
            [_vm._v("Agenzia " + _vm._s(_vm.token()) + " - Logout")]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e00fdf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e00fdf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/pages/layout/common/TopNavigation.vue
// module id = null
// module chunks = 